import { render, staticRenderFns } from "./AllNovelList.vue?vue&type=template&id=2217c24e&scoped=true&"
import script from "./AllNovelList.vue?vue&type=script&lang=js&"
export * from "./AllNovelList.vue?vue&type=script&lang=js&"
import style0 from "./AllNovelList.vue?vue&type=style&index=0&id=2217c24e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2217c24e",
  null
  
)

export default component.exports